
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb612"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb612"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lDOPP", function(module, exports) {

var $gmGs0 = parcelRequire("gmGs0");

var $ktVaQ = parcelRequire("ktVaQ");

var $lodVU = parcelRequire("lodVU");

var $bdSkQ = parcelRequire("bdSkQ");

var $fH3MG = parcelRequire("fH3MG");
const OBFUSCATED_FORMSPREE_ENDPOINT = "aHR0cHM6Ly9mb3Jtc3ByZWUuaW8vZi9tYmp3cGRwdw==";
const DATA_URL = "https://devious-digitizer-data.netlify.app/";
const cloneTemplate = (0, $lodVU.cloneTemplateFrom)(document);
customElements.define('closing-details', (0, $ktVaQ.ClosingDetails), {
    extends: 'details'
});
customElements.define('tab-panel', (0, $ktVaQ.TabPanel));
customElements.define('tab-group', (0, $ktVaQ.TabGroup));
customElements.define('tag-list', (0, $ktVaQ.TagList), {
    extends: 'ul'
});
customElements.define('modal-overlay', (0, $ktVaQ.ModalOverlay));
customElements.define('dialog-prompt', (0, $ktVaQ.DialogPrompt));
customElements.define('toast-box', (0, $ktVaQ.Toast));
//document.getElementById('landing_settings_link').addEventListener(
//    'click',
//    _ => document.body.append(settings(state.history[0].passage.title, routeTree))
//)
document.getElementById('landing_feedback_link').addEventListener('click', (_)=>document.body.append(feedback(null, null, null, navigator.userAgent)));
document.getElementById('landing_privacy_link').addEventListener('click', (_)=>document.body.append(privacy()));
document.getElementById('file_select').addEventListener('change', (e)=>switchToStory(e.target.files[0]));
const dragDropOverlay = document.getElementById('drag_drop_overlay');
document.body.addEventListener('dragenter', (e)=>{
    // TODO make nice drag drop overlay
    // new Overlay(null, ['Drag-and-drop icon goes here'])._overlay.open(document.body)
    e.preventDefault();
});
document.body.addEventListener('dragover', (e)=>e.preventDefault());
document.body.addEventListener('dragleave', (_)=>{
// document.querySelector('.drag_drop_overlay').close()
});
document.body.addEventListener('drop', (e)=>{
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files) switchToStory(e.dataTransfer.files[0]);
});
/// TEMPLATES ///
// FIX fadeTime is unimplemented
function toast(text, lingerTime = 3, fadeTime = 1) {
    const toast1 = document.createElement('toast-box');
    toast1.setAttribute('text', text);
    toast1.setAttribute('linger-time', lingerTime);
    //toast.setAttribute('fade-time', fadeTime)
    return toast1;
}
// modal prompt: "file does not appear to be a Devious World or Devious Mundanity file".
//      options: cancel (return false), try anyway (return true), clicking away is same as cancel
async function askToConfirm(filename) {
    return new Promise((res, rej)=>{
        const respond = (response)=>(e)=>{
                if (e.target == e.currentTarget) {
                    e.target.dispatchEvent((0, $ktVaQ.ModalOverlay).closeRequest);
                    res(response);
                }
            };
        const template = cloneTemplate('confirmation_template');
        const prompt = template.querySelector('.confirm_prompt');
        prompt.textContent = (0, $lodVU.substituteText)(prompt.textContent, {
            filename: filename
        });
        template.querySelector('modal-overlay').addEventListener('click', respond(false));
        template.querySelector('.cancel').addEventListener('click', respond(false));
        template.querySelector('.try_anyway').addEventListener('click', respond(true));
        document.body.append(template);
    });
}
function sidebarMenu(tale, state, routeTree, userAgent) {
    const template = cloneTemplate('sidebar_menu_template');
    template.querySelector('.settings_link').addEventListener('click', (_)=>document.body.append(settings(state.history[0].passage.title, routeTree)));
    template.querySelector('.feedback_link').addEventListener('click', (_)=>document.body.append(feedback(tale, state, routeTree, userAgent)));
    template.querySelector('.privacy_link').addEventListener('click', (_)=>document.body.append(privacy()));
    return template;
}
function settings(curr, routeTree) {
    const template = cloneTemplate('settings_template');
    const close = (e)=>{
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $ktVaQ.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.close_settings').addEventListener('click', close);
    const tagEditor = template.querySelector('.tag_editor');
    tagEditor.value = gatherTags(curr, routeTree).join(' ');
    template.querySelector('.save_tags').addEventListener('click', (_)=>{
        const psg = routeTree.get(curr);
        if (psg) psg.modifiedTags = tagEditor.value.split(' ');
        document.body.append(toast("tags saved!", 2));
    });
    // TODO? Add "revert tags" button
    template.querySelector('.export_metadata').addEventListener('click', (_)=>(0, $lodVU.exportObject)(extractMetadata(routeTree), 'metadata.json'));
    return template;
}
// Caches form to make filled-in info persistent
let feedbackForm;
function buildFeedback() {
    const template = cloneTemplate('feedback_template');
    const close = (e)=>{
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $ktVaQ.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.close_feedback').addEventListener('click', close);
    // give a visual indicator that debug_info is being disabled
    const debugInfo = template.querySelector('.debug_info');
    const includeDebugInfo = template.querySelector('.include_debug_info');
    includeDebugInfo.addEventListener('change', (_)=>{
        debugInfo.disabled = !includeDebugInfo.checked;
    });
    const submit = (type)=>(e)=>{
            e.preventDefault();
            const feedbackID = `${type}-${(0, $gmGs0.nanoid)(6)}`;
            // disable debug info when requested so it is not included in BUG feedback messages
            debugInfo.disabled = !includeDebugInfo.checked;
            const data = new FormData(e.target);
            data.append('id', feedbackID);
            const subject = `Devious Digitizer Feedback ${feedbackID}`;
            const body = [
                ...data.entries()
            ].map(([k, v])=>`${k}: ${v}`).join('\n\n');
            document.body.append(feedbackPreview(subject, body, e.target));
        };
    template.querySelector('.bug_report').addEventListener('submit', submit('BUG'));
    template.querySelector('.feature_request').addEventListener('submit', submit('REQ'));
    template.querySelector('.help_request').addEventListener('submit', submit('HLP'));
    template.querySelector('.submit_tags').addEventListener('submit', submit('TAG'));
    return template;
}
function feedback(tale, state, routeTree, userAgent) {
    feedbackForm !== null && feedbackForm !== void 0 ? feedbackForm : feedbackForm = buildFeedback().firstChild;
    feedbackForm.querySelector('.debug_info').textContent = gatherDebugInfo(tale, state, userAgent);
    if (routeTree !== null) feedbackForm.querySelector('.tag_changes').textContent = gatherTagChanges(routeTree);
    return feedbackForm;
}
function feedbackPreview(subject, body, form) {
    const template = cloneTemplate('feedback_preview_template');
    template.querySelector('.subject').textContent = subject;
    template.querySelector('.body').textContent = body;
    const close = (e)=>{
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $ktVaQ.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.cancel').addEventListener('click', close);
    template.querySelector('.submit').addEventListener('click', (e)=>{
        (0, $lodVU.encryptMessage)((0, (/*@__PURE__*/$parcel$interopDefault($bdSkQ))), body).then((encryptedBody)=>sendFormspree(subject, encryptedBody)).then((_)=>{
            form.reset();
            e.target.dispatchEvent((0, $ktVaQ.ModalOverlay).closeRequest);
            document.body.append(toast("feedback sent successfully ^_^"));
        }).catch((msg)=>alert(`something went wrong:\n${msg}`));
    });
    return template;
}
function privacy() {
    const template = cloneTemplate('privacy_template');
    const close = (e)=>{
        if (e.target == e.currentTarget) e.target.dispatchEvent((0, $ktVaQ.ModalOverlay).closeRequest);
    };
    template.querySelector('modal-overlay').addEventListener('click', close);
    template.querySelector('.close_privacy').addEventListener('click', close);
    return template;
}
function retrospective(curr, routeTree, tale) {
    var _routeTree_get_link, _routeTree_get;
    const template = cloneTemplate('retrospective_template');
    var _routeTree_get_link_text;
    template.querySelector('.choice--current').innerText = (_routeTree_get_link_text = (_routeTree_get = routeTree.get(curr)) === null || _routeTree_get === void 0 ? void 0 : (_routeTree_get_link = _routeTree_get.link) === null || _routeTree_get_link === void 0 ? void 0 : _routeTree_get_link.text) !== null && _routeTree_get_link_text !== void 0 ? _routeTree_get_link_text : '';
    template.querySelector('.past_passages').ontoggle = (e)=>{
        if (e.target.open) {
            e.target.ontoggle = null;
            e.target.prepend(...routeTree.getAncestryOf(curr).map((title)=>{
                var _routeTree_get_link, _routeTree_get;
                var _routeTree_get_link_text;
                return pastPassage((_routeTree_get_link_text = (_routeTree_get = routeTree.get(title)) === null || _routeTree_get === void 0 ? void 0 : (_routeTree_get_link = _routeTree_get.link) === null || _routeTree_get_link === void 0 ? void 0 : _routeTree_get_link.text) !== null && _routeTree_get_link_text !== void 0 ? _routeTree_get_link_text : 'Start', tale.get(title));
            }));
        }
    };
    return template;
}
function pastPassage(choice, psg) {
    const template = cloneTemplate('past_passage_template');
    template.querySelector('.choice--past').innerText = choice;
    template.querySelector('.past_passage__text').append(psg.render().querySelector('.body.content'));
    return template;
}
function passageTagViewer(tags) {
    const tagViewer = cloneTemplate('tag_viewer_template');
    tagViewer.querySelector('.tag_list').tags(tags);
    return tagViewer;
}
function inlineTagViewer(passageTags, routeTags) {
    const tagViewer = cloneTemplate('inline_tag_viewer_template');
    tagViewer.querySelector('.tag_list--passage').tags(passageTags);
    tagViewer.querySelector('.tag_list--route').tags(routeTags);
    return tagViewer;
}
/// Devious Digitizer ///
function gatherTags(title, routeTree, recursive = false) {
    var _routeTree_get, _routeTree_get1;
    var _routeTree_get_modifiedTags, _ref;
    if (!recursive) return (_ref = (_routeTree_get_modifiedTags = (_routeTree_get = routeTree.get(title)) === null || _routeTree_get === void 0 ? void 0 : _routeTree_get.modifiedTags) !== null && _routeTree_get_modifiedTags !== void 0 ? _routeTree_get_modifiedTags : (_routeTree_get1 = routeTree.get(title)) === null || _routeTree_get1 === void 0 ? void 0 : _routeTree_get1.tags) !== null && _ref !== void 0 ? _ref : [];
    return (0, $lodVU.arrayUnique)((0, $lodVU.Tree).cata(routeTree, title, (node)=>{
        var _node_modifiedTags, _ref;
        return ((_ref = (_node_modifiedTags = node.modifiedTags) !== null && _node_modifiedTags !== void 0 ? _node_modifiedTags : node.tags) !== null && _ref !== void 0 ? _ref : []).concat(...node.children);
    }));
// arrayUnique([...(node.tags ?? []), ...node.children.flatMap(child => gatherTags(child, routeTree, true))])
}
async function sendFormspree(subject, body) {
    const data = new FormData();
    data.append('subject', subject);
    data.append('body', body);
    const response = await fetch(atob(OBFUSCATED_FORMSPREE_ENDPOINT), {
        method: 'POST',
        body: data,
        headers: {
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        const errMsg = "There was a problem while trying to send your feedback. Please try again in a moment.";
        const data = await response.json();
        if (Object.hasOwn(data, 'errors')) throw new Error(errMsg + data["errors"].map((error)=>error["message"]).join(", "));
        else throw new Error(errMsg);
    }
}
function gatherDebugInfo(tale, state, userAgent) {
    return JSON.stringify({
        userAgent: userAgent,
        deviousVersion: tale === null || tale === void 0 ? void 0 : tale.title,
        currentPassage: state ? state.history[0].passage.title : null
    }, null, 2);
}
function gatherTagChanges(routeTree) {
    return JSON.stringify(Object.fromEntries([
        ...routeTree
    ].filter(([k, v])=>v.hasOwnProperty('modifiedTags')).map(([k, v])=>[
            k,
            v.modifiedTags
        ])), null, 2);
}
async function switchToStory(file) {
    const storyText = await file.text();
    const storyDoc = (0, $lodVU.parseDoc)(storyText);
    // is document one of DW or DM?
    if (!storyDoc.querySelector('#storeArea > [tiddler = "CharGenMain"]') && !storyDoc.querySelector('#storeArea > [tiddler = "Start"]')) {
        const confirmContinue = await askToConfirm(file.name);
        if (!confirmContinue) return;
    }
    hideLanding();
    loadDocIntoDom(storyDoc);
    await injectDigitizerFeatures();
}
function hideLanding() {
    document.querySelector('.digitizer-landing').classList.add('digitizer-landing--inactive');
}
function loadDocIntoDom(doc) {
    document.head.insertAdjacentHTML("beforeend", doc.head.innerHTML);
    document.body.insertAdjacentHTML("beforeend", doc.body.innerHTML);
    // Defining tiddlerTitle globally circumvents strict mode breaking Twine's scripts
    globalThis.tiddlerTitle = '';
    document.head.querySelectorAll('script[title]').forEach((s)=>eval(s.text));
    dispatchEvent(new Event('load'));
}
async function injectDigitizerFeatures() {
    const store = document.getElementById('storeArea');
    const passages = document.getElementById('passages');
    const tale = window.tale;
    const state = window.state;
    // determine whether this is DW or DM by checking which character starts are present
    const DWChars = [
        'allstarstart',
        'youngpunkstart',
        'quietonestart',
        'runawaystart',
        'GwynStart',
        'BuddyStart',
        'AustinStart',
        'DavidStart',
        'JackStart',
        'MikeStart',
        'ThaddeusStart',
        'SweetKidStart',
        'MeanGirlStart',
        'GirlGamerStart',
        'SelfSufficientStart',
        'CallistaStart',
        'BritStart',
        'WilmaStart',
        'HollyStart',
        'CelesteStart',
        'HelenStart',
        'MareiStart',
        'IreneStart'
    ];
    const DMChars = [
        'CaliburnStart',
        'DefianceStart',
        'EdithStart',
        'FionaStart',
        'IrethStart',
        'KaiStart',
        'KiaraStart',
        'KonkoStart',
        'LeoStart',
        'MaxiaStart',
        'NicholasStart',
        'SimoneStart',
        'SiphaStart',
        'ValerieStart',
        'YamiStart'
    ];
    const metadataName = DWChars.some(tale.has, tale) ? 'DW_metadata.json' : DMChars.some(tale.has, tale) ? 'DM_metadata.json' : (0, $lodVU.err)('Story is neither Worldly nor Mundane');
    // fetch the relevant metadata file from the server
    const metadata = await fetch(DATA_URL + metadataName).then((res)=>res.json());
    // build a graph from passages' links
    const passageGraph = buildPassageGraph(store);
    // render the graph into a tree of story routes by following links starting at CharGenMain and dropping cycles
    const routeTree = (0, $lodVU.Tree).fromGraphBfs((addChild, currentChild)=>passageGraph.forEachLinkedNode(currentChild, // add to tree and frontier unless, child is 'Version History', which breaks the tree. This is a big hack.
        (child, link)=>child.id !== 'Version History' ? addChild(child.id, Object.assign({
                link: link.data
            }, child.data)) : undefined, true // only traverse outbound links
        ), 'Start');
    // decorate routeTree with tags and other metadata
    routeTree.forEach((value, key)=>routeTree.set(key, Object.assign(value, metadata[key])));
    // dispatch events when switching passages
    window.state.display = function(title, source, type, callback) {
        passages.dispatchEvent(new CustomEvent('before_tale_display', {
            detail: {
                title: title,
                source: source,
                type: type,
                callback: callback
            }
        }));
        Object.getPrototypeOf(window.state).display.apply(this, [
            title,
            source,
            type,
            callback
        ]);
        passages.dispatchEvent(new CustomEvent('after_tale_display', {
            detail: {
                title: title,
                source: source,
                type: type,
                callback: callback
            }
        }));
    };
    // (Twine conveniently cleans out the previous passage's viewers while removing the previous passage)
    passages.addEventListener('after_tale_display', (e)=>{
        const curr = e.detail.title;
        // if we have metadata for current passage
        if (routeTree.has(curr)) {
            // above passage, add a viewer for current passage's tags and
            passages.prepend(passageTagViewer(gatherTags(curr, routeTree)));
            // if the current passage has preceding passages
            if (routeTree.get(curr).parent) // a retrospective of preceding passages
            passages.prepend(retrospective(curr, routeTree, tale));
        }
    });
    // add target passage name to passage links to assist in adding the inline tag viewers
    passages.addEventListener('after_tale_display', (e)=>annotateLinksWithTheirTarget(e.detail.title, tale, passages.querySelector('.passage.transition-in > .body')));
    // add inline tag viewer elements to new passages
    passages.addEventListener('after_tale_display', (e)=>addLinkTagLists(passages.querySelector('.passage.transition-in > .body'), routeTree));
    // Add sidebar links //
    document.getElementById('sidebar').append(sidebarMenu(tale, state, routeTree, navigator.userAgent));
}
const getLinks = (body)=>Array.from(body.matchAll(/\[\[(?:([^|]+)\|)?([^\]]+)\]\]/g)).map(([_, text, target])=>({
            text: text,
            target: target
        }));
function buildPassageGraph(storeArea) {
    const g = $fH3MG();
    const titles = new Set(Array.from(storeArea.children).map((el)=>el.getAttribute('tiddler')));
    for (const passage of storeArea.children){
        const title = passage.getAttribute('tiddler');
        for (const { text, target } of getLinks(passage.innerText))// only include links to passages that exist
        if (titles.has(target)) // create a link between the current and target passages, creating a node for the
        //   target passage if one does not yet exist, and annotating the link with its text
        g.addLink(title, target, {
            text: text
        });
    }
    return g;
}
function annotateLinksWithTheirTarget(title, tale, passageBody) {
    const linkTargets = getLinks(tale.get(title).text).map(({ target })=>target);
    const links = Array.from(passageBody.querySelectorAll('a'));
    for (const [link, target] of (0, $lodVU.take)(100, (0, $lodVU.zip)([
        links,
        linkTargets
    ])))link.setAttribute('data-target', target);
}
function addLinkTagLists(passageBody, routeTree) {
    passageBody.querySelectorAll('a[data-target]').forEach((link)=>{
        const title = link.getAttribute('data-target') // NOTE depends on annotateLinksWithTheirTarget
        ;
        // if target passage exists
        if (routeTree.has(title)) link.before(inlineTagViewer(gatherTags(title, routeTree, false), gatherTags(title, routeTree, true)));
    });
}
function extractMetadata(routeTree) {
    const include = new Set([
        'tags',
        'modifiedTags'
    ]);
    const strip = (value)=>(0, $lodVU.filterObjectByKey)(value, (key)=>include.has(key));
    return routeTree.toObject(([key, value])=>[
            key,
            strip(value)
        ]);
}

});
parcelRegister("gmGs0", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $be9fa13a19689010$export$ac4959f4f1338dfc; });

var $hHq9a = parcelRequire("hHq9a");
let $be9fa13a19689010$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $be9fa13a19689010$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        if (size <= 0) return '';
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $be9fa13a19689010$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$be9fa13a19689010$export$a5cee9e955a615e5(alphabet, size, $be9fa13a19689010$export$4385e60b38654f68);
let $be9fa13a19689010$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');

});
parcelRegister("hHq9a", function(module, exports) {
let $ce2abc07d2d47d2b$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});


parcelRegister("ktVaQ", function(module, exports) {

$parcel$export(module.exports, "ClosingDetails", function () { return $ee92dd9f2dc38bbd$export$ee7265346f578d9d; });
$parcel$export(module.exports, "TabPanel", function () { return $ee92dd9f2dc38bbd$export$3d96ec278d3efce4; });
$parcel$export(module.exports, "TabGroup", function () { return $ee92dd9f2dc38bbd$export$85fd4ed3b8ca1010; });
$parcel$export(module.exports, "TagList", function () { return $ee92dd9f2dc38bbd$export$f9fef0f55402315b; });
$parcel$export(module.exports, "ModalOverlay", function () { return $ee92dd9f2dc38bbd$export$8948f78d83984c69; });
$parcel$export(module.exports, "DialogPrompt", function () { return $ee92dd9f2dc38bbd$export$bf1308127b24ea84; });
$parcel$export(module.exports, "Toast", function () { return $ee92dd9f2dc38bbd$export$8d8dc7d5f743331b; });
// import * as petit from 'petit-dom'
// const el = petit.h
// const render = (parent, child, opts) => petit.render(child, parent, opts)
// import { el, mount } from 'redom'

var $hHuba = parcelRequire("hHuba");
parcelRequire("93MWr");
var $6woeQ = parcelRequire("6woeQ");

var $gmGs0 = parcelRequire("gmGs0");

var $lodVU = parcelRequire("lodVU");

var $cgW0f = parcelRequire("cgW0f");

var $eEy6s = parcelRequire("eEy6s");
const { stream: $ee92dd9f2dc38bbd$var$stream } = (0, (/*@__PURE__*/$parcel$interopDefault($cgW0f)));
const $ee92dd9f2dc38bbd$var$combine = (streams, fn)=>(0, (/*@__PURE__*/$parcel$interopDefault($cgW0f))).combine(fn, streams);
const $ee92dd9f2dc38bbd$var$update = (s, fn)=>s(fn(s()));
//const sideEffect = flyd.curryN(2, (fn, s) => flyd.map(x => {fn(x); return x;}, s))
const $ee92dd9f2dc38bbd$var$updateAttribute = (srm, attr, obj)=>(0, $lodVU.pipe)(srm, (0, $eEy6s.dropRepeats), (0, (/*@__PURE__*/$parcel$interopDefault($cgW0f))).on((x)=>obj.getAttribute(attr) === x ? null : obj.setAttribute(attr, x)));
class $ee92dd9f2dc38bbd$export$ee7265346f578d9d extends HTMLDetailsElement {
    connectedCallback() {
        document.body.addEventListener('mousedown', this._closeIfUnfocused);
    }
    disconnectedCallback() {
        document.body.removeEventListener('mousedown', this._closeIfUnfocused);
    }
    constructor(){
        super();
        this._closeIfUnfocused = (e)=>{
            if (!this.contains(document.elementFromPoint(e.clientX, e.clientY))) this.open = false;
        };
    }
}
class $ee92dd9f2dc38bbd$export$3d96ec278d3efce4 extends HTMLElement {
    connectedCallback() {
        var _this_getAttribute;
        this.title((_this_getAttribute = this.getAttribute('title')) !== null && _this_getAttribute !== void 0 ? _this_getAttribute : '');
        this.group(this.parentElement instanceof $ee92dd9f2dc38bbd$export$85fd4ed3b8ca1010 ? this.parentElement : null);
        this.id = this.id || (0, $gmGs0.nanoid)(10);
    }
    static get observedAttributes() {
        return [
            'id',
            'title'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'id') this.idChanged(null);
        else if (name === 'title') this.title(newVal);
    }
    constructor(){
        super(), (0, $hHuba._)(this, "idChanged", $ee92dd9f2dc38bbd$var$stream(null)), (0, $hHuba._)(this, "title", $ee92dd9f2dc38bbd$var$stream()), (0, $hHuba._)(this, "_onTitleChanged", $ee92dd9f2dc38bbd$var$updateAttribute(this.title, 'title', this)), (0, $hHuba._)(this, "group", $ee92dd9f2dc38bbd$var$stream()), (0, $hHuba._)(this, "active", $ee92dd9f2dc38bbd$var$combine([
            this.group.chain((g)=>g === null || g === void 0 ? void 0 : g.active),
            this.idChanged
        ], (gActive, _)=>{
            const active = gActive() === this.id;
            (0, $lodVU.setClass)(this, 'active', active);
            return active;
        }));
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.append((0, $6woeQ.default)('style', null, ':host {display: none;} :host(.active) {display: block;}'), (0, $6woeQ.default)('div', {
            role: 'tabpanel'
        }, (0, $6woeQ.default)('slot')));
    }
}
class $ee92dd9f2dc38bbd$export$85fd4ed3b8ca1010 extends HTMLElement {
    static get observedAttributes() {
        return [
            'active'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'active') this.active(newVal);
    }
    constructor(){
        super(), (0, $hHuba._)(this, "defaultTabTitle", ''), (0, $hHuba._)(this, "tabs", $ee92dd9f2dc38bbd$var$stream()), (0, $hHuba._)(this, "active", $ee92dd9f2dc38bbd$var$stream(null)), (0, $hHuba._)(this, "_onActiveChanged", $ee92dd9f2dc38bbd$var$updateAttribute(this.active, 'active', this)), (0, $hHuba._)(this, "renderTabList", $ee92dd9f2dc38bbd$var$combine([
            this.tabs,
            this.active
        ], (tabs, active)=>{
            // if `active` isn't a valid reference to a child tab-panel, default to the first tab-panel
            if (!tabs().some((el)=>el.id === active())) {
                var _tabs_;
                this.active((_tabs_ = tabs()[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.id);
                return;
            }
            this.shadowRoot.getElementById('tablist').replaceChildren(...tabs().map((tab)=>(0, $6woeQ.default)('li', {
                    class: 'tab' + (active() === tab.id ? ' active' : ''),
                    onclick: ()=>this.active(tab.id),
                    'aria-controls': tab.id,
                    role: 'tab'
                }, tab.title() || this.defaultTabTitle)));
        }));
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.append((0, $6woeQ.default)('style', null, `
                #tabgroup { display: flex; flex-flow: var(--tabs-position, column) nowrap; gap: var(--tablist-gap, 0); }
                #tablist { display: flex; flex-flow: var(--tabs-flow, row wrap); align-items: var(--tab-align); margin: 0;
                    padding: 0; gap: var(--tabs-gap, .5em); }
                .tab { display: block; background: var(--tab-background); cursor: var(--tab-cursor); padding: var(--tab-padding);
                    border: var(--tab-border); border-style: var(--tab-border-style); border-color: var(--tab-border-color);
                    border-width: var(--tab-border-width); border-radius: var(--tab-border-radius); }
                .tab.active { background: var(--tab-active-background); border: var(--tab-active-border);
                    border-style: var(--tab-active-border-style); border-color: var(--tab-active-border-color);
                    border-width: var(--tab-active-border-width); border-radius: var(--tab-active-border-radius); }`), (0, $6woeQ.default)('div', {
            part: 'tabgroup',
            role: 'wrapper',
            id: 'tabgroup'
        }, [
            (0, $6woeQ.default)('slot'),
            (0, $6woeQ.default)('menu', {
                part: 'tablist',
                role: 'tablist',
                id: 'tablist'
            })
        ]));
        this.shadowRoot.querySelector('slot').addEventListener('slotchange', (e)=>this.tabs(e.target.assignedElements().filter((x)=>x instanceof $ee92dd9f2dc38bbd$export$3d96ec278d3efce4)));
    }
}
class $ee92dd9f2dc38bbd$export$f9fef0f55402315b extends HTMLUListElement {
    connectedCallback() {
        this.connected(true);
    }
    constructor(...args){
        super(...args), (0, $hHuba._)(this, "connected", $ee92dd9f2dc38bbd$var$stream()), (0, $hHuba._)(this, "tags", $ee92dd9f2dc38bbd$var$stream([])), (0, $hHuba._)(this, "render", $ee92dd9f2dc38bbd$var$combine([
            this.tags,
            this.connected
        ], (tags)=>// TODO convert to using attodom.list?
            this.replaceChildren(...tags().sort().map((tag)=>(0, $6woeQ.default)('li', {
                    class: 'tag_list__tag'
                }, tag)))));
    }
}
class $ee92dd9f2dc38bbd$export$8948f78d83984c69 extends HTMLElement {
    open(parent) {
        parent.appendChild(this._overlay);
    }
    close() {
        this.remove();
    }
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.append((0, $6woeQ.default)('style', null, `
                #overlay {
                    display: var(--overlay-display, flex); flex-flow: column nowrap; justify-content: safe center;
                    align-items: center;

                    position: fixed; z-index: 1; left: 0; top: 0; width: 100%; height: 100%;
                    overflow: auto;

                    background-color: var(--overlay-color, rgba(0,0,0,0.4));
                }`), (0, $6woeQ.default)('div', {
            id: 'overlay'
        }, [
            (0, $6woeQ.default)('slot')
        ]));
        this.addEventListener('request_overlay_close', (e)=>{
            e.stopPropagation();
            this.close();
        });
    }
}
(0, $hHuba._)($ee92dd9f2dc38bbd$export$8948f78d83984c69, "closeRequest", new Event('request_overlay_close', {
    bubbles: true,
    cancelable: true
}));
class $ee92dd9f2dc38bbd$export$bf1308127b24ea84 extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.append((0, $6woeQ.default)('style', null, `
                #dialog {
                    background-color: var(--dialog-color, grey); padding: var(--dialog-padding, 2em);
                    border: var(--dialog-border); border-radius: var(--dialog-border-radius);
                }

                #buttons {
                    display: flex; flex-flow: row wrap; justify-content: space-around;
                    align-items: center; align-content: space-around; border: none;
                }`), (0, $6woeQ.default)('form', {
            id: 'dialog',
            onsubmit: (_)=>false
        }, [
            (0, $6woeQ.default)('slot', {
                name: 'prompt'
            }),
            (0, $6woeQ.default)('fieldset', {
                id: 'buttons'
            }, [
                (0, $6woeQ.default)('slot', {
                    name: 'buttons'
                })
            ])
        ]));
    }
}
class $ee92dd9f2dc38bbd$export$8d8dc7d5f743331b extends HTMLElement {
    connectedCallback() {
        const toast = this.shadowRoot.getElementById('toast');
        toast.textContent = this.getAttribute('text');
        (0, $lodVU.sleep)(Number(this.getAttribute('linger-time')) * 1000).then((_)=>toast.classList.add('fade'));
    }
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.append((0, $6woeQ.default)('style', null, `
                @keyframes fadeOut {
                    from {opacity: 1;}
                    to {opacity: 0;}
                }
                
                #toast {
                    background-color: var(--toast-color, grey); padding: var(--toast-padding, 2em);
                    border: var(--toast-border); border-radius: var(--toast-border-radius);
                    position: fixed; z-index: 1; left: 50%; bottom: 25%; transform: -50%;
                }
                
                #toast.fade {
                    animation: fadeOut 1s ease-in;
                }` // TODO make fade out time customizable
        ), (0, $6woeQ.default)('p', {
            id: 'toast'
        }));
        this.shadowRoot.getElementById('toast').addEventListener('animationend', (e)=>{
            if (e.animationName === 'fadeOut') this.remove();
        });
    }
}

});
parcelRegister("hHuba", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ce2ddcc9845ab8da$export$71511d61b312f219; });
function $ce2ddcc9845ab8da$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("93MWr", function(module, exports) {

$parcel$export(module.exports, "el", function () { return (parcelRequire("6woeQ")).default; });
// @ts-check
/* eslint-disable global-require */ 
var $6woeQ = parcelRequire("6woeQ");

var $5fQny = parcelRequire("5fQny");

var $5vTAX = parcelRequire("5vTAX");

var $1IN1y = parcelRequire("1IN1y");

var $5VDYt = parcelRequire("5VDYt");

});
parcelRegister("6woeQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf88878fae0618f$export$2e2bcd8739ae039; });

var $a8h9n = parcelRequire("a8h9n");
var $4bf88878fae0618f$var$htmlProps = {
    id: true,
    nodeValue: true,
    textContent: true,
    className: true,
    innerHTML: true,
    tabIndex: true,
    value: true
};
function $4bf88878fae0618f$export$2e2bcd8739ae039(tagName) {
    //@ts-ignore
    var node = tagName.nodeType === 1 ? tagName : document.createElement(tagName);
    for(var i = 1; i < arguments.length; ++i){
        var arg = arguments[i];
        if (arg != null) {
            //TODO skip .constructor
            if (!arg.constructor || arg.constructor === Object) for(var j = 0, ks = Object.keys(arg); j < ks.length; ++j){
                var key = ks[j], val = arg[key];
                if (key === 'style') node.style.cssText = val;
                else if (typeof val !== 'string' || $4bf88878fae0618f$var$htmlProps[key]) {
                    node[key] = val;
                    //set synthetic events for onUpperCaseName
                    if (key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) < 91 && key.charCodeAt(2) > 64 && !(0, $a8h9n.default)[key]) {
                        document.addEventListener(key.slice(2).toLowerCase(), function(e) {
                            var tgt = e.target;
                            do if (tgt[key]) return tgt[key](e);
                            while (tgt = tgt.parentNode);
                        });
                        (0, $a8h9n.default)[key] = true;
                    }
                } else node.setAttribute(key, val);
            }
            else {
                if (Array.isArray(arg)) for(var k = 0; k < arg.length; ++k)node.appendChild(arg[k].nodeType ? arg[k] : document.createTextNode(arg[k]));
                else node.appendChild(arg.nodeType ? arg : document.createTextNode(arg));
            }
        }
    }
    return node;
}

});
parcelRegister("a8h9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7607f46d1c117952$export$2e2bcd8739ae039; });
var $7607f46d1c117952$export$2e2bcd8739ae039 = {};

});


parcelRegister("5fQny", function(module, exports) {

var $a8h9n = parcelRequire("a8h9n");
function $3d36fbd0da931a23$export$2e2bcd8739ae039(tagName) {
    //@ts-ignore
    var node = tagName.nodeType === 1 ? tagName : document.createElementNS('http://www.w3.org/2000/svg', tagName);
    for(var i = 1; i < arguments.length; ++i){
        var arg = arguments[i];
        if (arg != null) {
            //TODO skip .constructor
            if (!arg.constructor || arg.constructor === Object) for(var j = 0, ks = Object.keys(arg); j < ks.length; ++j){
                var key = ks[j], val = arg[key];
                if (typeof val !== 'string') {
                    node[key] = val;
                    //set synthetic events for onUpperCaseName
                    if (key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) < 91 && key.charCodeAt(2) > 64 && !(0, $a8h9n.default)[key]) {
                        document.addEventListener(key.slice(2).toLowerCase(), function(e) {
                            var tgt = e.target;
                            do if (tgt[key]) return tgt[key](e);
                            while (tgt = tgt.parentNode);
                        });
                        (0, $a8h9n.default)[key] = true;
                    }
                } else node.setAttribute(key, val);
            }
            else {
                if (Array.isArray(arg)) for(var k = 0; k < arg.length; ++k)node.appendChild(arg[k].nodeType ? arg[k] : document.createTextNode(arg[k]));
                else node.appendChild(arg.nodeType ? arg : document.createTextNode(arg));
            }
        }
    }
    return node;
}

});

parcelRegister("5vTAX", function(module, exports) {
/**
 * @param {Element} parent
 * @param {Function} factory
 * @param {Object} [options]
 * @return {Object}
 */ function $403af904300c3b1d$export$2e2bcd8739ae039(parent, factory, options) {
    return {
        parent: parent,
        factory: factory,
        before: options && options.before || null,
        after: options && options.after || null,
        update: $403af904300c3b1d$var$updateList,
        key: options && options.key || ((v, i)=>i),
        map: Object.create(null)
    };
}
/**
 * @param {Array} arr
 * @return {Node}
 */ function $403af904300c3b1d$var$updateList(arr) {
    var parent = this.parent, spot = this.after ? this.after.nextSibling : parent.firstChild, getK = this.key, kids = Object.create(null);
    if (!arr.length && !this.before && !this.after) parent.textContent = '';
    else {
        for(var i = 0; i < arr.length; ++i){
            //TODO skip .constructor
            var key = getK.constructor === Function ? getK(arr[i], i, arr) : arr[i][getK], kid = this.map[key];
            //create or update kid
            if (kid) kid.update && kid.update(arr[i], key, arr) //eslint-disable-line
            ;
            else kid = this.factory(arr[i], i, arr);
            kids[key] = kid;
            //place kid
            if (!spot) parent.appendChild(kid);
            else if (kid === spot.nextSibling) parent.removeChild(spot);
            else if (kid !== spot) parent.insertBefore(kid, spot);
            spot = kid.nextSibling;
        }
        //delete remaining
        while(spot !== this.before){
            var next = spot.nextSibling;
            parent.removeChild(spot);
            spot = next;
        }
    }
    this.map = kids;
    return this;
}

});

parcelRegister("1IN1y", function(module, exports) {
function $140feda7886506ec$export$2e2bcd8739ae039(start, test, until) {
    var spot = start, last = until || null;
    while(!test(spot)){
        if (spot === last) return null // specified end reached
        ;
        var next = spot.firstChild;
        // if no child get sibling, if no sibling, retry with parent
        if (!next) while(!(next = spot.nextSibling)){
            spot = spot.parentNode;
            if (spot === null) return null // end of tree reached
            ;
        }
        spot = next;
    }
    return spot;
}

});

parcelRegister("5VDYt", function(module, exports) {
/**
 * @param {string} cssRuleText
 * @return {void}
 */ function $451148b96baee387$export$2e2bcd8739ae039(cssRuleText) {
    /**@type {CSSStyleSheet} */ //@ts-ignore
    var sheet = document.styleSheets[0] || document.head.appendChild(document.createElement('style')).sheet;
    sheet.insertRule(cssRuleText, sheet.cssRules.length);
}

});


parcelRegister("lodVU", function(module, exports) {

$parcel$export(module.exports, "setClass", function () { return $f926a5a5b972730f$export$2796c4ce44e61efa; });
$parcel$export(module.exports, "err", function () { return $f926a5a5b972730f$export$8048b892d651b310; });
$parcel$export(module.exports, "sleep", function () { return $f926a5a5b972730f$export$e772c8ff12451969; });
$parcel$export(module.exports, "pipe", function () { return $f926a5a5b972730f$export$a4627e546088548d; });
$parcel$export(module.exports, "zip", function () { return $f926a5a5b972730f$export$8901015135f2fb22; });
$parcel$export(module.exports, "take", function () { return $f926a5a5b972730f$export$b7df5d561049483a; });
$parcel$export(module.exports, "arrayUnique", function () { return $f926a5a5b972730f$export$7bf6fd20e75fd96; });
$parcel$export(module.exports, "filterObjectByKey", function () { return $f926a5a5b972730f$export$cf80d7b87eda7a5b; });
$parcel$export(module.exports, "substituteText", function () { return $f926a5a5b972730f$export$f7404bda8d1e381c; });
$parcel$export(module.exports, "Tree", function () { return $f926a5a5b972730f$export$7fbedc92909ed28e; });
$parcel$export(module.exports, "cloneTemplateFrom", function () { return $f926a5a5b972730f$export$42e04a57be803477; });
$parcel$export(module.exports, "parseDoc", function () { return $f926a5a5b972730f$export$5db361593220645; });
$parcel$export(module.exports, "exportObject", function () { return $f926a5a5b972730f$export$ac1f1552ea16f7d5; });
$parcel$export(module.exports, "encryptMessage", function () { return $f926a5a5b972730f$export$802132930513888b; });

var $hHuba = parcelRequire("hHuba");

var $3fsI9 = parcelRequire("3fsI9");

var $01RPR = parcelRequire("01RPR");

var $oNJRK = parcelRequire("oNJRK");
const $f926a5a5b972730f$export$411ce8e5a71e3069 = (x, y)=>x === y;
const $f926a5a5b972730f$export$2796c4ce44e61efa = (elem, cl, bool)=>bool ? elem.classList.add(cl) : elem.classList.remove(cl);
const $f926a5a5b972730f$export$8048b892d651b310 = (...args)=>{
    throw new Error(...args);
};
const $f926a5a5b972730f$export$e772c8ff12451969 = (ms)=>new Promise((res)=>setTimeout(res, ms));
const $f926a5a5b972730f$export$a4627e546088548d = (x, ...fns)=>fns.reduce((acc, fn)=>fn(acc), x);
const $f926a5a5b972730f$export$ccc7b0636abaffc3 = (...fns)=>(x)=>fns.reduce((acc, fn)=>fn(acc), x);
const $f926a5a5b972730f$export$8901015135f2fb22 = (rows)=>rows[0].map((_, c)=>rows.map((row)=>row[c]));
function* $f926a5a5b972730f$export$b7df5d561049483a(n, iter) {
    for (const x of iter){
        if (n < 1) break;
        yield x;
        n -= 1;
    }
}
function $f926a5a5b972730f$export$667066422fa0af46(...sets) {
    const union = new Set(sets.shift());
    for (const currSet of sets)for (const elem of currSet)union.add(elem);
    return union;
}
const $f926a5a5b972730f$export$7bf6fd20e75fd96 = (arr)=>Array.from(new Set(arr));
function $f926a5a5b972730f$export$485830fe756029f5(obj, pred) {
    return Object.fromEntries(Object.entries(obj).filter(pred));
}
function $f926a5a5b972730f$export$cf80d7b87eda7a5b(obj, pred) {
    return $f926a5a5b972730f$export$485830fe756029f5(obj, ([key, _])=>pred(key));
}
const $f926a5a5b972730f$export$f7404bda8d1e381c = (template, context)=>template.replaceAll(/{(\w+)}/g, (match, key)=>{
        var _context_key;
        return (_context_key = context[key]) !== null && _context_key !== void 0 ? _context_key : match;
    });
class $f926a5a5b972730f$export$7fbedc92909ed28e extends Map {
    setRoot(node, attributes = {}) {
        if (this.root !== null) throw new Error(`root '${this.root}' already exists`);
        this.set(node, Object.assign(attributes, {
            children: [],
            parent: null
        }));
        this.root = node;
    }
    addChild(parent, child, attributes = {}) {
        var _this_get_children, _this_get;
        if (this.get(child) !== undefined) throw new Error(`child ${child} already exists`);
        var _this_get_children_push;
        (_this_get_children_push = (_this_get = this.get(parent)) === null || _this_get === void 0 ? void 0 : (_this_get_children = _this_get.children) === null || _this_get_children === void 0 ? void 0 : _this_get_children.push(child)) !== null && _this_get_children_push !== void 0 ? _this_get_children_push : $f926a5a5b972730f$export$8048b892d651b310(`parent '${parent}' does not exist or is malformed`);
        this.set(child, Object.assign(attributes, {
            children: [],
            parent: parent
        }));
    }
    deleteNode(node) {
        for (const child of this.get(node).children)this.deleteNode(child);
        this.delete(node);
    }
    toObject(morphism) {
        if (typeof morphism === 'function') return Object.fromEntries(Array.from(this, morphism));
        else return Object.fromEntries(this);
    }
    getAncestryOf(node) {
        const ancestry = [];
        let parent = this.get(node).parent;
        while(parent !== null){
            ancestry.unshift(parent);
            parent = this.get(parent).parent;
        }
        return ancestry;
    }
    // I don't trust this algorithm. Does it have bugs? Is it efficient? Does it cover all edge
    //   cases? No clue. But it's not recursive.
    // Collapses `tree` into a single value using an accumulator function `f` (similar to `reduce`)
    //   optionally starting at subtree `node`. `f` is passed each node except the node's
    //   `children` attribute instead holds the results of applying `f` to the node's children.
    static cata(tree, node = null, f) {
        const newLayer = (node)=>({
                node: node,
                before: [
                    ...tree.get(node).children
                ],
                after: []
            });
        const stack = [
            newLayer(node !== null && node !== void 0 ? node : tree.root)
        ];
        while(true)if (stack.at(-1).before.length) stack.push(newLayer(stack.at(-1).before.pop()));
        else {
            const curr = stack.pop();
            const res = f((0, $01RPR._)((0, $3fsI9._)({}, tree.get(curr.node)), {
                children: curr.after
            }));
            if (!stack.length) return res;
            stack.at(-1).after.push(res);
        }
    }
    static fromGraphBfs(getChildren, root) {
        const tree = new $f926a5a5b972730f$export$7fbedc92909ed28e(root);
        const frontier = [
            root
        ];
        const addChildOf = (currentNode)=>(id, data = {})=>{
                if (!tree.has(id)) {
                    frontier.push(id);
                    tree.addChild(currentNode, id, data);
                }
            };
        while(frontier.length > 0){
            const currentNode = frontier.pop();
            getChildren(addChildOf(currentNode), currentNode);
        }
        return tree;
    }
    constructor(root, attributes = {}){
        super(), (0, $hHuba._)(this, "root", null);
        if (root) this.setRoot(root, attributes);
    }
}
const $f926a5a5b972730f$export$42e04a57be803477 = (doc)=>(templateId)=>{
        // NOTE importNode works like cloneNode except it upgrades custom elements. Needed because
        //   it works on template contents, unlike customElements.upgrade.
        const template = doc.importNode(doc.getElementById(templateId).content, true);
        // clear the fragment of extraneous nodes that might break things
        // TODO Apply recursively to comments
        Array.from(template.childNodes).forEach((el)=>{
            if (el.nodeName === '#text' && !el.nodeValue.trim() || el.nodeName === '#comment') el.remove();
        });
        return template;
    };
function $f926a5a5b972730f$export$5db361593220645(docText) {
    return new DOMParser().parseFromString(docText, "text/html");
}
function $f926a5a5b972730f$export$ac1f1552ea16f7d5(obj, filename) {
    (0, $oNJRK.saveAs)(new Blob([
        JSON.stringify(obj)
    ], {
        type: 'application/json'
    }), filename);
}

async function $f926a5a5b972730f$export$802132930513888b(armoredPublicKey, text) {
    const { readKey: readKey, encrypt: encrypt, createMessage: createMessage } = await (parcelRequire("9lNGS"));
    return await encrypt({
        message: await createMessage({
            text: text
        }),
        encryptionKeys: await readKey({
            armoredKey: armoredPublicKey
        })
    });
}

});
parcelRegister("3fsI9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $25d90b3cfab03f41$export$71511d61b312f219; });

var $hHuba = parcelRequire("hHuba");
function $25d90b3cfab03f41$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $hHuba._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("01RPR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0059dabd18dd0769$export$71511d61b312f219; });
function $0059dabd18dd0769$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0059dabd18dd0769$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $0059dabd18dd0769$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("oNJRK", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("9lNGS", function(module, exports) {

module.exports = (parcelRequire("akl07"))($parcel$resolve("gwDts")).then(()=>parcelRequire('26wHK'));

});
parcelRegister("akl07", function(module, exports) {
"use strict";

var $ex78I = parcelRequire("ex78I");
module.exports = $ex78I(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("ex78I", function(module, exports) {
"use strict";
var $a949af897dfa2ad9$var$cachedBundles = {};
var $a949af897dfa2ad9$var$cachedPreloads = {};
var $a949af897dfa2ad9$var$cachedPrefetches = {};
function $a949af897dfa2ad9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a949af897dfa2ad9$var$cachedPreloads;
        case 'prefetch':
            return $a949af897dfa2ad9$var$cachedPrefetches;
        default:
            return $a949af897dfa2ad9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a949af897dfa2ad9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("cgW0f", function(module, exports) {
'use strict';

var $1nYwi = parcelRequire("1nYwi");
// Utility
function $8ef3f8dcd7822723$var$isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}
function $8ef3f8dcd7822723$var$trueFn() {
    return true;
}
// Globals
var $8ef3f8dcd7822723$var$toUpdate = [];
var $8ef3f8dcd7822723$var$inStream;
var $8ef3f8dcd7822723$var$order = [];
var $8ef3f8dcd7822723$var$orderNextIdx = -1;
var $8ef3f8dcd7822723$var$flushingUpdateQueue = false;
var $8ef3f8dcd7822723$var$flushingStreamValue = false;
function $8ef3f8dcd7822723$var$flushing() {
    return $8ef3f8dcd7822723$var$flushingUpdateQueue || $8ef3f8dcd7822723$var$flushingStreamValue;
}
/** @namespace */ var $8ef3f8dcd7822723$var$flyd = {};
// /////////////////////////// API ///////////////////////////////// //
/**
 * Creates a new stream
 *
 * __Signature__: `a -> Stream a`
 *
 * @name flyd.stream
 * @param {*} initialValue - (Optional) the initial value of the stream
 * @return {stream} the stream
 *
 * @example
 * var n = flyd.stream(1); // Stream with initial value `1`
 * var s = flyd.stream(); // Stream with no initial value
 */ $8ef3f8dcd7822723$var$flyd.stream = function(initialValue) {
    var endStream = $8ef3f8dcd7822723$var$createDependentStream([], $8ef3f8dcd7822723$var$trueFn);
    var s = $8ef3f8dcd7822723$var$createStream();
    s.end = endStream;
    s.fnArgs = [];
    endStream.listeners.push(s);
    if (arguments.length > 0) s(initialValue);
    return s;
};
// fantasy-land Applicative
$8ef3f8dcd7822723$var$flyd.stream['fantasy-land/of'] = $8ef3f8dcd7822723$var$flyd.stream.of = $8ef3f8dcd7822723$var$flyd.stream;
/**
 * Create a new dependent stream
 *
 * __Signature__: `(...Stream * -> Stream b -> b) -> [Stream *] -> Stream b`
 *
 * @name flyd.combine
 * @param {Function} fn - the function used to combine the streams
 * @param {Array<stream>} dependencies - the streams that this one depends on
 * @return {stream} the dependent stream
 *
 * @example
 * var n1 = flyd.stream(0);
 * var n2 = flyd.stream(0);
 * var max = flyd.combine(function(n1, n2, self, changed) {
 *   return n1() > n2() ? n1() : n2();
 * }, [n1, n2]);
 */ $8ef3f8dcd7822723$var$flyd.combine = $1nYwi(2, $8ef3f8dcd7822723$var$combine);
function $8ef3f8dcd7822723$var$combine(fn, streams) {
    var i, s, deps, depEndStreams;
    var endStream = $8ef3f8dcd7822723$var$createDependentStream([], $8ef3f8dcd7822723$var$trueFn);
    deps = [];
    depEndStreams = [];
    for(i = 0; i < streams.length; ++i)if (streams[i] !== undefined) {
        deps.push(streams[i]);
        if (streams[i].end !== undefined) depEndStreams.push(streams[i].end);
    }
    s = $8ef3f8dcd7822723$var$createDependentStream(deps, fn);
    s.depsChanged = [];
    s.fnArgs = s.deps.concat([
        s,
        s.depsChanged
    ]);
    s.end = endStream;
    endStream.listeners.push(s);
    $8ef3f8dcd7822723$var$addListeners(depEndStreams, endStream);
    endStream.deps = depEndStreams;
    $8ef3f8dcd7822723$var$updateStream(s);
    return s;
}
/**
 * Returns `true` if the supplied argument is a Flyd stream and `false` otherwise.
 *
 * __Signature__: `* -> Boolean`
 *
 * @name flyd.isStream
 * @param {*} value - the value to test
 * @return {Boolean} `true` if is a Flyd streamn, `false` otherwise
 *
 * @example
 * var s = flyd.stream(1);
 * var n = 1;
 * flyd.isStream(s); //=> true
 * flyd.isStream(n); //=> false
 */ $8ef3f8dcd7822723$var$flyd.isStream = function(stream) {
    return $8ef3f8dcd7822723$var$isFunction(stream) && 'hasVal' in stream;
};
/**
 * Invokes the body (the function to calculate the value) of a dependent stream
 *
 * By default the body of a dependent stream is only called when all the streams
 * upon which it depends has a value. `immediate` can circumvent this behaviour.
 * It immediately invokes the body of a dependent stream.
 *
 * __Signature__: `Stream a -> Stream a`
 *
 * @name flyd.immediate
 * @param {stream} stream - the dependent stream
 * @return {stream} the same stream
 *
 * @example
 * var s = flyd.stream();
 * var hasItems = flyd.immediate(flyd.combine(function(s) {
 *   return s() !== undefined && s().length > 0;
 * }, [s]);
 * console.log(hasItems()); // logs `false`. Had `immediate` not been
 *                          // used `hasItems()` would've returned `undefined`
 * s([1]);
 * console.log(hasItems()); // logs `true`.
 * s([]);
 * console.log(hasItems()); // logs `false`.
 */ $8ef3f8dcd7822723$var$flyd.immediate = function(s) {
    if (s.depsMet === false) {
        s.depsMet = true;
        $8ef3f8dcd7822723$var$updateStream(s);
    }
    return s;
};
/**
 * Changes which `endsStream` should trigger the ending of `s`.
 *
 * __Signature__: `Stream a -> Stream b -> Stream b`
 *
 * @name flyd.endsOn
 * @param {stream} endStream - the stream to trigger the ending
 * @param {stream} stream - the stream to be ended by the endStream
 * @param {stream} the stream modified to be ended by endStream
 *
 * @example
 * var n = flyd.stream(1);
 * var killer = flyd.stream();
 * // `double` ends when `n` ends or when `killer` emits any value
 * var double = flyd.endsOn(flyd.merge(n.end, killer), flyd.combine(function(n) {
 *   return 2 * n();
 * }, [n]);
*/ $8ef3f8dcd7822723$var$flyd.endsOn = function(endS, s) {
    $8ef3f8dcd7822723$var$detachDeps(s.end);
    endS.listeners.push(s.end);
    s.end.deps.push(endS);
    return s;
};
/**
 * Map a stream
 *
 * Returns a new stream consisting of every value from `s` passed through
 * `fn`. I.e. `map` creates a new stream that listens to `s` and
 * applies `fn` to every new value.
 * __Signature__: `(a -> result) -> Stream a -> Stream result`
 *
 * @name flyd.map
 * @param {Function} fn - the function that produces the elements of the new stream
 * @param {stream} stream - the stream to map
 * @return {stream} a new stream with the mapped values
 *
 * @example
 * var numbers = flyd.stream(0);
 * var squaredNumbers = flyd.map(function(n) { return n*n; }, numbers);
 */ // Library functions use self callback to accept (null, undefined) update triggers.
function $8ef3f8dcd7822723$var$map(f, s) {
    return $8ef3f8dcd7822723$var$combine(function(s, self) {
        self(f(s.val));
    }, [
        s
    ]);
}
$8ef3f8dcd7822723$var$flyd.map = $1nYwi(2, $8ef3f8dcd7822723$var$map);
/**
 * Chain a stream
 *
 * also known as flatMap
 *
 * Where `fn` returns a stream this function will flatten the resulting streams.
 * Every time `fn` is called the context of the returned stream will "switch" to that stream.
 *
 * __Signature__: `(a -> Stream b) -> Stream a -> Stream b`
 *
 * @name flyd.chain
 * @param {Function} fn - the function that produces the streams to be flattened
 * @param {stream} stream - the stream to map
 * @return {stream} a new stream with the mapped values
 *
 * @example
 * var filter = flyd.stream('who');
 * var items = flyd.chain(function(filter){
 *   return flyd.stream(findUsers(filter));
 * }, filter);
 */ $8ef3f8dcd7822723$var$flyd.chain = $1nYwi(2, $8ef3f8dcd7822723$var$chain);
/**
 * Apply a stream
 *
 * Applies the value in `s2` to the function in `s1`.
 *
 * __Signature__: `Stream (a -> b) -> Stream a -> Stream b`
 *
 * @name flyd.ap
 * @param {stream} s1 - The value to be applied
 * @param {stream} s2 - The function expecting the value
 * @return {stream} a new stream with the mapped values
 *
 * @example
 * var add = stream(a => b => a + b)
 * var n1 = stream(1)
 * var n2 = stream(2)
 *
 * var added = flyd.ap(n2, flyd.ap(n1, add)) // stream(3)
 * // can also be written using pipe
 * var added_pipe = add
 *   .pipe(ap(n1))
 *   .pipe(ap(n2));
 * added_pipe() // 3
 */ $8ef3f8dcd7822723$var$flyd.ap = $1nYwi(2, $8ef3f8dcd7822723$var$ap);
/**
 * Listen to stream events
 *
 * Similar to `map` except that the returned stream is empty. Use `on` for doing
 * side effects in reaction to stream changes. Use the returned stream only if you
 * need to manually end it.
 *
 * __Signature__: `(a -> result) -> Stream a -> Stream undefined`
 *
 * @name flyd.on
 * @param {Function} cb - the callback
 * @param {stream} stream - the stream
 * @return {stream} an empty stream (can be ended)
 */ $8ef3f8dcd7822723$var$flyd.on = $1nYwi(2, function(f, s) {
    return $8ef3f8dcd7822723$var$combine(function(s) {
        f(s.val);
    }, [
        s
    ]);
});
/**
 * Creates a new stream with the results of calling the function on every incoming
 * stream with and accumulator and the incoming value.
 *
 * __Signature__: `(a -> b -> a) -> a -> Stream b -> Stream a`
 *
 * @name flyd.scan
 * @param {Function} fn - the function to call
 * @param {*} val - the initial value of the accumulator
 * @param {stream} stream - the stream source
 * @return {stream} the new stream
 *
 * @example
 * var numbers = flyd.stream();
 * var sum = flyd.scan(function(sum, n) { return sum+n; }, 0, numbers);
 * numbers(2)(3)(5);
 * sum(); // 10
 */ $8ef3f8dcd7822723$var$flyd.scan = $1nYwi(3, function(f, acc, s) {
    var ns = $8ef3f8dcd7822723$var$combine(function(s, self) {
        self(acc = f(acc, s.val));
    }, [
        s
    ]);
    if (!ns.hasVal) ns(acc);
    return ns;
});
/**
 * Creates a new stream down which all values from both `stream1` and `stream2`
 * will be sent.
 *
 * __Signature__: `Stream a -> Stream a -> Stream a`
 *
 * @name flyd.merge
 * @param {stream} source1 - one stream to be merged
 * @param {stream} source2 - the other stream to be merged
 * @return {stream} a stream with the values from both sources
 *
 * @example
 * var btn1Clicks = flyd.stream();
 * button1Elm.addEventListener(btn1Clicks);
 * var btn2Clicks = flyd.stream();
 * button2Elm.addEventListener(btn2Clicks);
 * var allClicks = flyd.merge(btn1Clicks, btn2Clicks);
 */ $8ef3f8dcd7822723$var$flyd.merge = $1nYwi(2, function(s1, s2) {
    var s = $8ef3f8dcd7822723$var$flyd.immediate($8ef3f8dcd7822723$var$combine(function(s1, s2, self, changed) {
        if (changed[0]) self(changed[0]());
        else if (s1.hasVal) self(s1.val);
        else if (s2.hasVal) self(s2.val);
    }, [
        s1,
        s2
    ]));
    $8ef3f8dcd7822723$var$flyd.endsOn($8ef3f8dcd7822723$var$combine(function() {
        return true;
    }, [
        s1.end,
        s2.end
    ]), s);
    return s;
});
/**
 * Creates a new stream resulting from applying `transducer` to `stream`.
 *
 * __Signature__: `Transducer -> Stream a -> Stream b`
 *
 * @name flyd.transduce
 * @param {Transducer} xform - the transducer transformation
 * @param {stream} source - the stream source
 * @return {stream} the new stream
 *
 * @example
 * var t = require('transducers.js');
 *
 * var results = [];
 * var s1 = flyd.stream();
 * var tx = t.compose(t.map(function(x) { return x * 2; }), t.dedupe());
 * var s2 = flyd.transduce(tx, s1);
 * flyd.combine(function(s2) { results.push(s2()); }, [s2]);
 * s1(1)(1)(2)(3)(3)(3)(4);
 * results; // => [2, 4, 6, 8]
 */ $8ef3f8dcd7822723$var$flyd.transduce = $1nYwi(2, function(xform, source) {
    xform = xform(new $8ef3f8dcd7822723$var$StreamTransformer());
    return $8ef3f8dcd7822723$var$combine(function(source, self) {
        var res = xform['@@transducer/step'](undefined, source.val);
        if (res && res['@@transducer/reduced'] === true) {
            self.end(true);
            return res['@@transducer/value'];
        } else return res;
    }, [
        source
    ]);
});
/**
 * Returns `fn` curried to `n`. Use this function to curry functions exposed by
 * modules for Flyd.
 *
 * @name flyd.curryN
 * @function
 * @param {Integer} arity - the function arity
 * @param {Function} fn - the function to curry
 * @return {Function} the curried function
 *
 * @example
 * function add(x, y) { return x + y; };
 * var a = flyd.curryN(2, add);
 * a(2)(4) // => 6
 */ $8ef3f8dcd7822723$var$flyd.curryN = $1nYwi;
/**
 * Returns a new stream identical to the original except every
 * value will be passed through `f`.
 *
 * _Note:_ This function is included in order to support the fantasy land
 * specification.
 *
 * __Signature__: Called bound to `Stream a`: `(a -> b) -> Stream b`
 *
 * @name stream.map
 * @param {Function} function - the function to apply
 * @return {stream} a new stream with the values mapped
 *
 * @example
 * var numbers = flyd.stream(0);
 * var squaredNumbers = numbers.map(function(n) { return n*n; });
 */ function $8ef3f8dcd7822723$var$boundMap(f) {
    return $8ef3f8dcd7822723$var$map(f, this);
}
/**
 * Returns the result of applying function `fn` to this stream
 *
 * __Signature__: Called bound to `Stream a`: `(a -> Stream b) -> Stream b`
 *
 * @name stream.pipe
 * @param {Function} fn - the function to apply
 * @return {stream} A new stream
 *
 * @example
 * var numbers = flyd.stream(0);
 * var squaredNumbers = numbers.pipe(flyd.map(function(n){ return n*n; }));
 */ function $8ef3f8dcd7822723$var$operator_pipe(f) {
    return f(this);
}
function $8ef3f8dcd7822723$var$boundChain(f) {
    return $8ef3f8dcd7822723$var$chain(f, this);
}
function $8ef3f8dcd7822723$var$chain(f, s) {
    // Internal state to end flat map stream
    var flatEnd = $8ef3f8dcd7822723$var$flyd.stream(1);
    var internalEnded = $8ef3f8dcd7822723$var$flyd.on(function() {
        var alive = flatEnd() - 1;
        flatEnd(alive);
        if (alive <= 0) flatEnd.end(true);
    });
    internalEnded(s.end);
    var last = $8ef3f8dcd7822723$var$flyd.stream();
    var flatStream = $8ef3f8dcd7822723$var$flyd.combine(function(s, own) {
        last.end(true);
        // Our fn stream makes streams
        var newS = f(s());
        flatEnd(flatEnd() + 1);
        internalEnded(newS.end);
        // Update self on call -- newS is never handed out so deps don't matter
        last = $8ef3f8dcd7822723$var$map(own, newS);
    }, [
        s
    ]);
    $8ef3f8dcd7822723$var$flyd.endsOn(flatEnd.end, flatStream);
    return flatStream;
}
$8ef3f8dcd7822723$var$flyd.fromPromise = function fromPromise(p) {
    var s = $8ef3f8dcd7822723$var$flyd.stream();
    p.then(function(val) {
        s(val);
        s.end(true);
    });
    return s;
};
$8ef3f8dcd7822723$var$flyd.flattenPromise = function flattenPromise(s) {
    return $8ef3f8dcd7822723$var$combine(function(s, self) {
        s().then(self);
    }, [
        s
    ]);
};
/**
 * Returns a new stream which is the result of applying the
 * functions from `this` stream to the values in `stream` parameter.
 *
 * `this` stream must be a stream of functions.
 *
 * _Note:_ This function is included in order to support the fantasy land
 * specification.
 *
 * __Signature__: Called bound to `Stream (a -> b)`: `a -> Stream b`
 *
 * @name stream.ap
 * @param {stream} stream - the values stream
 * @return {stream} a new stream with the functions applied to values
 *
 * @example
 * var add = flyd.curryN(2, function(x, y) { return x + y; });
 * var numbers1 = flyd.stream();
 * var numbers2 = flyd.stream();
 * var addToNumbers1 = flyd.map(add, numbers1);
 * var added = addToNumbers1.ap(numbers2);
 */ function $8ef3f8dcd7822723$var$ap(s2, s1) {
    return $8ef3f8dcd7822723$var$combine(function(s1, s2, self) {
        self(s1.val(s2.val));
    }, [
        s1,
        s2
    ]);
}
function $8ef3f8dcd7822723$var$boundAp(s2) {
    return $8ef3f8dcd7822723$var$ap(s2, this);
}
/**
 * @private
 */ function $8ef3f8dcd7822723$var$fantasy_land_ap(s1) {
    return $8ef3f8dcd7822723$var$ap(this, s1);
}
/**
 * Get a human readable view of a stream
 * @name stream.toString
 * @return {String} the stream string representation
 */ function $8ef3f8dcd7822723$var$streamToString() {
    return 'stream(' + this.val + ')';
}
/**
 * @name stream.end
 * @memberof stream
 * A stream that emits `true` when the stream ends. If `true` is pushed down the
 * stream the parent stream ends.
 */ /**
 * @name stream.of
 * @function
 * @memberof stream
 * Returns a new stream with `value` as its initial value. It is identical to
 * calling `flyd.stream` with one argument.
 *
 * __Signature__: Called bound to `Stream (a)`: `b -> Stream b`
 *
 * @param {*} value - the initial value
 * @return {stream} the new stream
 *
 * @example
 * var n = flyd.stream(1);
 * var m = n.of(1);
 */ // /////////////////////////// PRIVATE ///////////////////////////////// //
/**
 * @private
 * Create a stream with no dependencies and no value
 * @return {Function} a flyd stream
 */ function $8ef3f8dcd7822723$var$createStream() {
    function s(n) {
        if (arguments.length === 0) return s.val;
        $8ef3f8dcd7822723$var$updateStreamValue(n, s);
        return s;
    }
    s.hasVal = false;
    s.val = undefined;
    s.updaters = [];
    s.listeners = [];
    s.queued = false;
    s.end = undefined;
    // fantasy-land compatibility
    s.ap = $8ef3f8dcd7822723$var$boundAp;
    s['fantasy-land/map'] = s.map = $8ef3f8dcd7822723$var$boundMap;
    s['fantasy-land/ap'] = $8ef3f8dcd7822723$var$fantasy_land_ap;
    s['fantasy-land/of'] = s.of = $8ef3f8dcd7822723$var$flyd.stream;
    s['fantasy-land/chain'] = s.chain = $8ef3f8dcd7822723$var$boundChain;
    s.pipe = $8ef3f8dcd7822723$var$operator_pipe;
    // According to the fantasy-land Applicative specification
    // Given a value f, one can access its type representative via the constructor property:
    // `f.constructor.of`
    s.constructor = $8ef3f8dcd7822723$var$flyd.stream;
    s.toJSON = function() {
        return s.val;
    };
    s.toString = $8ef3f8dcd7822723$var$streamToString;
    return s;
}
/**
 * @private
 * Create a dependent stream
 * @param {Array<stream>} dependencies - an array of the streams
 * @param {Function} fn - the function used to calculate the new stream value
 * from the dependencies
 * @return {stream} the created stream
 */ function $8ef3f8dcd7822723$var$createDependentStream(deps, fn) {
    var s = $8ef3f8dcd7822723$var$createStream();
    s.fn = fn;
    s.deps = deps;
    s.depsMet = false;
    s.depsChanged = deps.length > 0 ? [] : undefined;
    s.shouldUpdate = false;
    $8ef3f8dcd7822723$var$addListeners(deps, s);
    return s;
}
/**
 * @private
 * Check if all the dependencies have values
 * @param {stream} stream - the stream to check depencencies from
 * @return {Boolean} `true` if all dependencies have vales, `false` otherwise
 */ function $8ef3f8dcd7822723$var$initialDependenciesMet(stream) {
    stream.depsMet = stream.deps.every(function(s) {
        return s.hasVal;
    });
    return stream.depsMet;
}
function $8ef3f8dcd7822723$var$dependenciesAreMet(stream) {
    return stream.depsMet === true || $8ef3f8dcd7822723$var$initialDependenciesMet(stream);
}
function $8ef3f8dcd7822723$var$isEnded(stream) {
    return stream.end && stream.end.val === true;
}
function $8ef3f8dcd7822723$var$listenersNeedUpdating(s) {
    return s.listeners.some(function(s) {
        return s.shouldUpdate;
    });
}
/**
 * @private
 * Update a dependent stream using its dependencies in an atomic way
 * @param {stream} stream - the stream to update
 */ function $8ef3f8dcd7822723$var$updateStream(s) {
    if ($8ef3f8dcd7822723$var$isEnded(s) || !$8ef3f8dcd7822723$var$dependenciesAreMet(s)) return;
    if ($8ef3f8dcd7822723$var$inStream !== undefined) {
        $8ef3f8dcd7822723$var$updateLaterUsing($8ef3f8dcd7822723$var$updateStream, s);
        return;
    }
    $8ef3f8dcd7822723$var$inStream = s;
    if (s.depsChanged) s.fnArgs[s.fnArgs.length - 1] = s.depsChanged;
    var returnVal = s.fn.apply(s.fn, s.fnArgs);
    if (returnVal !== undefined) s(returnVal);
    $8ef3f8dcd7822723$var$inStream = undefined;
    if (s.depsChanged !== undefined) s.depsChanged = [];
    s.shouldUpdate = false;
    if ($8ef3f8dcd7822723$var$flushing() === false) $8ef3f8dcd7822723$var$flushUpdate();
    if ($8ef3f8dcd7822723$var$listenersNeedUpdating(s)) {
        if (!$8ef3f8dcd7822723$var$flushingStreamValue) s(s.val);
        else s.listeners.forEach(function(listener) {
            if (listener.shouldUpdate) $8ef3f8dcd7822723$var$updateLaterUsing($8ef3f8dcd7822723$var$updateStream, listener);
        });
    }
}
/**
 * @private
 * Update the dependencies of a stream
 * @param {stream} stream
 */ function $8ef3f8dcd7822723$var$updateListeners(s) {
    var i, o, list;
    var listeners = s.listeners;
    for(i = 0; i < listeners.length; ++i){
        list = listeners[i];
        if (list.end === s) $8ef3f8dcd7822723$var$endStream(list);
        else {
            if (list.depsChanged !== undefined) list.depsChanged.push(s);
            list.shouldUpdate = true;
            $8ef3f8dcd7822723$var$findDeps(list);
        }
    }
    for(; $8ef3f8dcd7822723$var$orderNextIdx >= 0; --$8ef3f8dcd7822723$var$orderNextIdx){
        o = $8ef3f8dcd7822723$var$order[$8ef3f8dcd7822723$var$orderNextIdx];
        if (o.shouldUpdate === true) $8ef3f8dcd7822723$var$updateStream(o);
        o.queued = false;
    }
}
/**
 * @private
 * Add stream dependencies to the global `order` queue.
 * @param {stream} stream
 * @see updateDeps
 */ function $8ef3f8dcd7822723$var$findDeps(s) {
    var i;
    var listeners = s.listeners;
    if (s.queued === false) {
        s.queued = true;
        for(i = 0; i < listeners.length; ++i)$8ef3f8dcd7822723$var$findDeps(listeners[i]);
        $8ef3f8dcd7822723$var$order[++$8ef3f8dcd7822723$var$orderNextIdx] = s;
    }
}
function $8ef3f8dcd7822723$var$updateLaterUsing(updater, stream) {
    $8ef3f8dcd7822723$var$toUpdate.push(stream);
    stream.updaters.push(updater);
    stream.shouldUpdate = true;
}
/**
 * @private
 */ function $8ef3f8dcd7822723$var$flushUpdate() {
    $8ef3f8dcd7822723$var$flushingUpdateQueue = true;
    while($8ef3f8dcd7822723$var$toUpdate.length > 0){
        var stream = $8ef3f8dcd7822723$var$toUpdate.shift();
        var nextUpdateFn = stream.updaters.shift();
        if (nextUpdateFn && stream.shouldUpdate) nextUpdateFn(stream);
    }
    $8ef3f8dcd7822723$var$flushingUpdateQueue = false;
}
/**
 * @private
 * Push down a value into a stream
 * @param {stream} stream
 * @param {*} value
 */ function $8ef3f8dcd7822723$var$updateStreamValue(n, s) {
    s.val = n;
    s.hasVal = true;
    if ($8ef3f8dcd7822723$var$inStream === undefined) {
        $8ef3f8dcd7822723$var$flushingStreamValue = true;
        $8ef3f8dcd7822723$var$updateListeners(s);
        if ($8ef3f8dcd7822723$var$toUpdate.length > 0) $8ef3f8dcd7822723$var$flushUpdate();
        $8ef3f8dcd7822723$var$flushingStreamValue = false;
    } else if ($8ef3f8dcd7822723$var$inStream === s) $8ef3f8dcd7822723$var$markListeners(s, s.listeners);
    else $8ef3f8dcd7822723$var$updateLaterUsing(function(s) {
        $8ef3f8dcd7822723$var$updateStreamValue(n, s);
    }, s);
}
/**
 * @private
 */ function $8ef3f8dcd7822723$var$markListeners(s, lists) {
    var i, list;
    for(i = 0; i < lists.length; ++i){
        list = lists[i];
        if (list.end !== s) {
            if (list.depsChanged !== undefined) list.depsChanged.push(s);
            list.shouldUpdate = true;
        } else $8ef3f8dcd7822723$var$endStream(list);
    }
}
/**
 * @private
 * Add dependencies to a stream
 * @param {Array<stream>} dependencies
 * @param {stream} stream
 */ function $8ef3f8dcd7822723$var$addListeners(deps, s) {
    for(var i = 0; i < deps.length; ++i)deps[i].listeners.push(s);
}
/**
 * @private
 * Removes an stream from a dependency array
 * @param {stream} stream
 * @param {Array<stream>} dependencies
 */ function $8ef3f8dcd7822723$var$removeListener(s, listeners) {
    var idx = listeners.indexOf(s);
    listeners[idx] = listeners[listeners.length - 1];
    listeners.length--;
}
/**
 * @private
 * Detach a stream from its dependencies
 * @param {stream} stream
 */ function $8ef3f8dcd7822723$var$detachDeps(s) {
    for(var i = 0; i < s.deps.length; ++i)$8ef3f8dcd7822723$var$removeListener(s, s.deps[i].listeners);
    s.deps.length = 0;
}
/**
 * @private
 * Ends a stream
 */ function $8ef3f8dcd7822723$var$endStream(s) {
    if (s.deps !== undefined) $8ef3f8dcd7822723$var$detachDeps(s);
    if (s.end !== undefined) $8ef3f8dcd7822723$var$detachDeps(s.end);
}
/**
 * @private
 */ /**
 * @private
 * transducer stream transformer
 */ function $8ef3f8dcd7822723$var$StreamTransformer() {}
$8ef3f8dcd7822723$var$StreamTransformer.prototype['@@transducer/init'] = function() {};
$8ef3f8dcd7822723$var$StreamTransformer.prototype['@@transducer/result'] = function() {};
$8ef3f8dcd7822723$var$StreamTransformer.prototype['@@transducer/step'] = function(s, v) {
    return v;
};
module.exports = $8ef3f8dcd7822723$var$flyd;

});
parcelRegister("1nYwi", function(module, exports) {

var $6eJYh = parcelRequire("6eJYh");

var $j78DI = parcelRequire("j78DI");

var $1dUzI = parcelRequire("1dUzI");

var $fOv2B = parcelRequire("fOv2B");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */ var $1026e2650a4010d0$var$curryN = /*#__PURE__*/ $1dUzI(function curryN(length, fn) {
    if (length === 1) return $j78DI(fn);
    return $6eJYh(length, $fOv2B(length, [], fn));
});
module.exports = $1026e2650a4010d0$var$curryN;

});
parcelRegister("6eJYh", function(module, exports) {
function $48a7b5d4ddf74e9f$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $48a7b5d4ddf74e9f$var$_arity;

});

parcelRegister("j78DI", function(module, exports) {

var $keqXc = parcelRequire("keqXc");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $dea55f6a9524720d$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $keqXc(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $dea55f6a9524720d$var$_curry1;

});
parcelRegister("keqXc", function(module, exports) {
function $ebaa05ec1c894155$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $ebaa05ec1c894155$var$_isPlaceholder;

});


parcelRegister("1dUzI", function(module, exports) {

var $j78DI = parcelRequire("j78DI");

var $keqXc = parcelRequire("keqXc");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $0e42e3f2b5bc9379$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $keqXc(a) ? f2 : $j78DI(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $keqXc(a) && $keqXc(b) ? f2 : $keqXc(a) ? $j78DI(function(_a) {
                    return fn(_a, b);
                }) : $keqXc(b) ? $j78DI(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $0e42e3f2b5bc9379$var$_curry2;

});

parcelRegister("fOv2B", function(module, exports) {

var $6eJYh = parcelRequire("6eJYh");

var $keqXc = parcelRequire("keqXc");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $b8339a99f14f761a$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$keqXc(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$keqXc(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $6eJYh(left, $b8339a99f14f761a$var$_curryN(length, combined, fn));
    };
}
module.exports = $b8339a99f14f761a$var$_curryN;

});



parcelRegister("eEy6s", function(module, exports) {

$parcel$export(module.exports, "dropRepeats", function () { return $aaaf41478e6408ed$export$f42b5f849eadee29; }, function (v) { return $aaaf41478e6408ed$export$f42b5f849eadee29 = v; });
var $aaaf41478e6408ed$export$f42b5f849eadee29;
var $aaaf41478e6408ed$export$a047232242a2c3d2;

var $cgW0f = parcelRequire("cgW0f");
function $aaaf41478e6408ed$var$dropRepeatsWith(eq, s) {
    var prev;
    return $cgW0f.combine(function(s, self) {
        if (!self.hasVal || !eq(s.val, prev)) {
            self(s.val);
            prev = s.val;
        }
    }, [
        s
    ]);
}
$aaaf41478e6408ed$export$f42b5f849eadee29 = function(s) {
    return $aaaf41478e6408ed$var$dropRepeatsWith($aaaf41478e6408ed$var$strictEq, s);
};
$aaaf41478e6408ed$export$a047232242a2c3d2 = $cgW0f.curryN(2, $aaaf41478e6408ed$var$dropRepeatsWith);
function $aaaf41478e6408ed$var$strictEq(a, b) {
    return a === b;
}

});


parcelRegister("bdSkQ", function(module, exports) {
module.exports = "-----BEGIN PGP PUBLIC KEY BLOCK-----\n\nxjMEYf8cKBYJKwYBBAHaRw8BAQdAHE6JBN/PRr/7ZLFhb5vLLrKSWJLXxNpG\nMbqVZccBAL3NOVdpY2tlZFdpdGNoNkBwcm90b25tYWlsLmNvbSA8V2lja2Vk\nV2l0Y2g2QHByb3Rvbm1haWwuY29tPsKPBBAWCgAgBQJh/xwoBgsJBwgDAgQV\nCAoCBBYCAQACGQECGwMCHgEAIQkQ4GeD5hotLgUWIQTKTXvpnWFrweQb09Dg\nZ4PmGi0uBSUaAP44QKmwpTeK+oioSWo3qY4TpfXcz7d4qi49tmADmb6G8QEA\n1FEUMJllc9Qq3xiACBY/O5XIXsAlLlu1cAe2vkNcKgTOOARh/xwoEgorBgEE\nAZdVAQUBAQdAPj3oEz8PeUhGvxXZ4CYy8ejL/SiS8gyWPlAI2f2RWn4DAQgH\nwngEGBYIAAkFAmH/HCgCGwwAIQkQ4GeD5hotLgUWIQTKTXvpnWFrweQb09Dg\nZ4PmGi0uBf9zAP9tggzcytwB2XGu2c50Pfa0IZSEEiWnhN2A7uQRtqAKNAD/\nRQPybgO7rHpk9XjjHvqk87NYWAkj2kCCgK5rK+cYjwk=\n=9jDO\n-----END PGP PUBLIC KEY BLOCK-----\n";

});

parcelRegister("fH3MG", function(module, exports) {
/**
 * @fileOverview Contains definition of the core graph object.
 */ // TODO: need to change storage layer:
// 1. Be able to get all nodes O(1)
// 2. Be able to get number of links O(1)
/**
 * @example
 *  var graph = require('ngraph.graph')();
 *  graph.addNode(1);     // graph has one node.
 *  graph.addLink(2, 3);  // now graph contains three nodes and one link.
 *
 */ module.exports = $b6cdce9dcc025a1f$var$createGraph;

var $bS1IX = parcelRequire("bS1IX");
/**
 * Creates a new graph
 */ function $b6cdce9dcc025a1f$var$createGraph(options) {
    // Graph structure is maintained as dictionary of nodes
    // and array of links. Each node has 'links' property which
    // hold all links related to that node. And general links
    // array is used to speed up all links enumeration. This is inefficient
    // in terms of memory, but simplifies coding.
    options = options || {};
    if ('uniqueLinkId' in options) {
        console.warn("ngraph.graph: Starting from version 0.14 `uniqueLinkId` is deprecated.\nUse `multigraph` option instead\n", '\n', "Note: there is also change in default behavior: From now on each graph\nis considered to be not a multigraph by default (each edge is unique).");
        options.multigraph = options.uniqueLinkId;
    }
    // Dear reader, the non-multigraphs do not guarantee that there is only
    // one link for a given pair of node. When this option is set to false
    // we can save some memory and CPU (18% faster for non-multigraph);
    if (options.multigraph === undefined) options.multigraph = false;
    if (typeof Map !== 'function') // TODO: Should we polyfill it ourselves? We don't use much operations there..
    throw new Error('ngraph.graph requires `Map` to be defined. Please polyfill it before using ngraph');
    var nodes = new Map();
    var links = [], // Hash of multi-edges. Used to track ids of edges between same nodes
    multiEdges = {}, suspendEvents = 0, createLink = options.multigraph ? createUniqueLink : createSingleLink, // Our graph API provides means to listen to graph changes. Users can subscribe
    // to be notified about changes in the graph by using `on` method. However
    // in some cases they don't use it. To avoid unnecessary memory consumption
    // we will not record graph changes until we have at least one subscriber.
    // Code below supports this optimization.
    //
    // Accumulates all changes made during graph updates.
    // Each change element contains:
    //  changeType - one of the strings: 'add', 'remove' or 'update';
    //  node - if change is related to node this property is set to changed graph's node;
    //  link - if change is related to link this property is set to changed graph's link;
    changes = [], recordLinkChange = noop, recordNodeChange = noop, enterModification = noop, exitModification = noop;
    // this is our public API:
    var graphPart = {
        /**
     * Adds node to the graph. If node with given id already exists in the graph
     * its data is extended with whatever comes in 'data' argument.
     *
     * @param nodeId the node's identifier. A string or number is preferred.
     * @param [data] additional data for the node being added. If node already
     *   exists its data object is augmented with the new one.
     *
     * @return {node} The newly added node or node with given id if it already exists.
     */ addNode: addNode,
        /**
     * Adds a link to the graph. The function always create a new
     * link between two nodes. If one of the nodes does not exists
     * a new node is created.
     *
     * @param fromId link start node id;
     * @param toId link end node id;
     * @param [data] additional data to be set on the new link;
     *
     * @return {link} The newly created link
     */ addLink: addLink,
        /**
     * Removes link from the graph. If link does not exist does nothing.
     *
     * @param link - object returned by addLink() or getLinks() methods.
     *
     * @returns true if link was removed; false otherwise.
     */ removeLink: removeLink,
        /**
     * Removes node with given id from the graph. If node does not exist in the graph
     * does nothing.
     *
     * @param nodeId node's identifier passed to addNode() function.
     *
     * @returns true if node was removed; false otherwise.
     */ removeNode: removeNode,
        /**
     * Gets node with given identifier. If node does not exist undefined value is returned.
     *
     * @param nodeId requested node identifier;
     *
     * @return {node} in with requested identifier or undefined if no such node exists.
     */ getNode: getNode,
        /**
     * Gets number of nodes in this graph.
     *
     * @return number of nodes in the graph.
     */ getNodeCount: getNodeCount,
        /**
     * Gets total number of links in the graph.
     */ getLinkCount: getLinkCount,
        /**
     * Synonym for `getLinkCount()`
     */ getLinksCount: getLinkCount,
        /**
     * Synonym for `getNodeCount()`
     */ getNodesCount: getNodeCount,
        /**
     * Gets all links (inbound and outbound) from the node with given id.
     * If node with given id is not found null is returned.
     *
     * @param nodeId requested node identifier.
     *
     * @return Array of links from and to requested node if such node exists;
     *   otherwise null is returned.
     */ getLinks: getLinks,
        /**
     * Invokes callback on each node of the graph.
     *
     * @param {Function(node)} callback Function to be invoked. The function
     *   is passed one argument: visited node.
     */ forEachNode: forEachNode,
        /**
     * Invokes callback on every linked (adjacent) node to the given one.
     *
     * @param nodeId Identifier of the requested node.
     * @param {Function(node, link)} callback Function to be called on all linked nodes.
     *   The function is passed two parameters: adjacent node and link object itself.
     * @param oriented if true graph treated as oriented.
     */ forEachLinkedNode: forEachLinkedNode,
        /**
     * Enumerates all links in the graph
     *
     * @param {Function(link)} callback Function to be called on all links in the graph.
     *   The function is passed one parameter: graph's link object.
     *
     * Link object contains at least the following fields:
     *  fromId - node id where link starts;
     *  toId - node id where link ends,
     *  data - additional data passed to graph.addLink() method.
     */ forEachLink: forEachLink,
        /**
     * Suspend all notifications about graph changes until
     * endUpdate is called.
     */ beginUpdate: enterModification,
        /**
     * Resumes all notifications about graph changes and fires
     * graph 'changed' event in case there are any pending changes.
     */ endUpdate: exitModification,
        /**
     * Removes all nodes and links from the graph.
     */ clear: clear,
        /**
     * Detects whether there is a link between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     * NOTE: this function is synonim for getLink()
     *
     * @returns link if there is one. null otherwise.
     */ hasLink: getLink,
        /**
     * Detects whether there is a node with given id
     * 
     * Operation complexity is O(1)
     * NOTE: this function is synonim for getNode()
     *
     * @returns node if there is one; Falsy value otherwise.
     */ hasNode: getNode,
        /**
     * Gets an edge between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     *
     * @param {string} fromId link start identifier
     * @param {string} toId link end identifier
     *
     * @returns link if there is one. null otherwise.
     */ getLink: getLink
    };
    // this will add `on()` and `fire()` methods.
    $bS1IX(graphPart);
    monitorSubscribers();
    return graphPart;
    function monitorSubscribers() {
        var realOn = graphPart.on;
        // replace real `on` with our temporary on, which will trigger change
        // modification monitoring:
        graphPart.on = on;
        function on() {
            // now it's time to start tracking stuff:
            graphPart.beginUpdate = enterModification = enterModificationReal;
            graphPart.endUpdate = exitModification = exitModificationReal;
            recordLinkChange = recordLinkChangeReal;
            recordNodeChange = recordNodeChangeReal;
            // this will replace current `on` method with real pub/sub from `eventify`.
            graphPart.on = realOn;
            // delegate to real `on` handler:
            return realOn.apply(graphPart, arguments);
        }
    }
    function recordLinkChangeReal(link, changeType) {
        changes.push({
            link: link,
            changeType: changeType
        });
    }
    function recordNodeChangeReal(node, changeType) {
        changes.push({
            node: node,
            changeType: changeType
        });
    }
    function addNode(nodeId, data) {
        if (nodeId === undefined) throw new Error('Invalid node identifier');
        enterModification();
        var node = getNode(nodeId);
        if (!node) {
            node = new $b6cdce9dcc025a1f$var$Node(nodeId, data);
            recordNodeChange(node, 'add');
        } else {
            node.data = data;
            recordNodeChange(node, 'update');
        }
        nodes.set(nodeId, node);
        exitModification();
        return node;
    }
    function getNode(nodeId) {
        return nodes.get(nodeId);
    }
    function removeNode(nodeId) {
        var node = getNode(nodeId);
        if (!node) return false;
        enterModification();
        var prevLinks = node.links;
        if (prevLinks) {
            node.links = null;
            for(var i = 0; i < prevLinks.length; ++i)removeLink(prevLinks[i]);
        }
        nodes.delete(nodeId);
        recordNodeChange(node, 'remove');
        exitModification();
        return true;
    }
    function addLink(fromId, toId, data) {
        enterModification();
        var fromNode = getNode(fromId) || addNode(fromId);
        var toNode = getNode(toId) || addNode(toId);
        var link = createLink(fromId, toId, data);
        links.push(link);
        // TODO: this is not cool. On large graphs potentially would consume more memory.
        $b6cdce9dcc025a1f$var$addLinkToNode(fromNode, link);
        if (fromId !== toId) // make sure we are not duplicating links for self-loops
        $b6cdce9dcc025a1f$var$addLinkToNode(toNode, link);
        recordLinkChange(link, 'add');
        exitModification();
        return link;
    }
    function createSingleLink(fromId, toId, data) {
        var linkId = $b6cdce9dcc025a1f$var$makeLinkId(fromId, toId);
        return new $b6cdce9dcc025a1f$var$Link(fromId, toId, data, linkId);
    }
    function createUniqueLink(fromId, toId, data) {
        // TODO: Get rid of this method.
        var linkId = $b6cdce9dcc025a1f$var$makeLinkId(fromId, toId);
        var isMultiEdge = multiEdges.hasOwnProperty(linkId);
        if (isMultiEdge || getLink(fromId, toId)) {
            if (!isMultiEdge) multiEdges[linkId] = 0;
            var suffix = '@' + ++multiEdges[linkId];
            linkId = $b6cdce9dcc025a1f$var$makeLinkId(fromId + suffix, toId + suffix);
        }
        return new $b6cdce9dcc025a1f$var$Link(fromId, toId, data, linkId);
    }
    function getNodeCount() {
        return nodes.size;
    }
    function getLinkCount() {
        return links.length;
    }
    function getLinks(nodeId) {
        var node = getNode(nodeId);
        return node ? node.links : null;
    }
    function removeLink(link) {
        if (!link) return false;
        var idx = $b6cdce9dcc025a1f$var$indexOfElementInArray(link, links);
        if (idx < 0) return false;
        enterModification();
        links.splice(idx, 1);
        var fromNode = getNode(link.fromId);
        var toNode = getNode(link.toId);
        if (fromNode) {
            idx = $b6cdce9dcc025a1f$var$indexOfElementInArray(link, fromNode.links);
            if (idx >= 0) fromNode.links.splice(idx, 1);
        }
        if (toNode) {
            idx = $b6cdce9dcc025a1f$var$indexOfElementInArray(link, toNode.links);
            if (idx >= 0) toNode.links.splice(idx, 1);
        }
        recordLinkChange(link, 'remove');
        exitModification();
        return true;
    }
    function getLink(fromNodeId, toNodeId) {
        // TODO: Use sorted links to speed this up
        var node = getNode(fromNodeId), i;
        if (!node || !node.links) return null;
        for(i = 0; i < node.links.length; ++i){
            var link = node.links[i];
            if (link.fromId === fromNodeId && link.toId === toNodeId) return link;
        }
        return null; // no link.
    }
    function clear() {
        enterModification();
        forEachNode(function(node) {
            removeNode(node.id);
        });
        exitModification();
    }
    function forEachLink(callback) {
        var i, length;
        if (typeof callback === 'function') for(i = 0, length = links.length; i < length; ++i)callback(links[i]);
    }
    function forEachLinkedNode(nodeId, callback, oriented) {
        var node = getNode(nodeId);
        if (node && node.links && typeof callback === 'function') {
            if (oriented) return forEachOrientedLink(node.links, nodeId, callback);
            else return forEachNonOrientedLink(node.links, nodeId, callback);
        }
    }
    function forEachNonOrientedLink(links, nodeId, callback) {
        var quitFast;
        for(var i = 0; i < links.length; ++i){
            var link = links[i];
            var linkedNodeId = link.fromId === nodeId ? link.toId : link.fromId;
            quitFast = callback(nodes.get(linkedNodeId), link);
            if (quitFast) return true; // Client does not need more iterations. Break now.
        }
    }
    function forEachOrientedLink(links, nodeId, callback) {
        var quitFast;
        for(var i = 0; i < links.length; ++i){
            var link = links[i];
            if (link.fromId === nodeId) {
                quitFast = callback(nodes.get(link.toId), link);
                if (quitFast) return true; // Client does not need more iterations. Break now.
            }
        }
    }
    // we will not fire anything until users of this library explicitly call `on()`
    // method.
    function noop() {}
    // Enter, Exit modification allows bulk graph updates without firing events.
    function enterModificationReal() {
        suspendEvents += 1;
    }
    function exitModificationReal() {
        suspendEvents -= 1;
        if (suspendEvents === 0 && changes.length > 0) {
            graphPart.fire('changed', changes);
            changes.length = 0;
        }
    }
    function forEachNode(callback) {
        if (typeof callback !== 'function') throw new Error('Function is expected to iterate over graph nodes. You passed ' + callback);
        var valuesIterator = nodes.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
            nextValue = valuesIterator.next();
        }
    }
}
// need this for old browsers. Should this be a separate module?
function $b6cdce9dcc025a1f$var$indexOfElementInArray(element, array) {
    if (!array) return -1;
    if (array.indexOf) return array.indexOf(element);
    var len = array.length, i;
    for(i = 0; i < len; i += 1){
        if (array[i] === element) return i;
    }
    return -1;
}
/**
 * Internal structure to represent node;
 */ function $b6cdce9dcc025a1f$var$Node(id, data) {
    this.id = id;
    this.links = null;
    this.data = data;
}
function $b6cdce9dcc025a1f$var$addLinkToNode(node, link) {
    if (node.links) node.links.push(link);
    else node.links = [
        link
    ];
}
/**
 * Internal structure to represent links;
 */ function $b6cdce9dcc025a1f$var$Link(fromId, toId, data, id) {
    this.fromId = fromId;
    this.toId = toId;
    this.data = data;
    this.id = id;
}
function $b6cdce9dcc025a1f$var$makeLinkId(fromId, toId) {
    return fromId.toString() + "\uD83D\uDC49 " + toId.toString();
}

});
parcelRegister("bS1IX", function(module, exports) {
module.exports = function eventify(subject) {
    $023aefcb5e397a7e$var$validateSubject(subject);
    var eventsStorage = $023aefcb5e397a7e$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $023aefcb5e397a7e$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            var wantToRemoveAll = typeof eventName === 'undefined';
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== 'function';
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $023aefcb5e397a7e$var$validateSubject(subject) {
    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
    var reservedWords = [
        'on',
        'fire',
        'off'
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}

});



var $8851953e4a75c11d$exports = {};
$parcel$extendImportMap({
    "gwDts": "openpgp.min.2352881d.js"
});


parcelRequire("lDOPP");

//# sourceMappingURL=app.1c54fdf1.js.map
